import { GLOBAL_CONFIGURATION } from "./constants";

export const ONLY_ONE_STATION = GLOBAL_CONFIGURATION.storefilter?.length === 1;
export const REQUIRE_LOGIN_TO_CHECKOUT = !(
  GLOBAL_CONFIGURATION.allowAnonymousCheckout === true
);
export const ORDER_SOURCE_KEY = GLOBAL_CONFIGURATION.ordersource ?? "ORDERWEB";
